import _slicedToArray from "E:/code/nkyOrder/trunk/vantCommon/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getConsentFormCount as _getConsentFormCount, getConsentFormList as _getConsentFormList, getWeChatMessageCount as _getWeChatMessageCount } from '@/api/module/index';
import { decrypt } from '../../assets/utils/cryptoUtil.js';
export default {
  name: "index",
  data: function data() {
    return {
      activeTabs: 0,
      active: window.g.VUE_APP_MESSAGE_NOTIFICATION ? 2 : 1,
      quests: [],
      questList: [],
      typeid: '',
      answers: [],
      answerShow: false,
      serialNo: '',
      filterShow: false,
      show: false,
      startDate: null,
      endDate: null,
      iconColor: '#000000',
      screenTimeShow: 1,
      task: 0,
      // 待办任务数量
      messageCount: 0,
      // 消息数量
      messageShow: window.g.VUE_APP_MESSAGE_NOTIFICATION,
      messageInterval: null // 定时器引用

    };
  },
  created: function created() {
    this.serialNo = this.$route.query.serialNo;
    console.log("serialNo", this.serialNo);
    this.getConsentFormList();
    this.screenTime(this.screenTimeShow);
    this.getConsentFormCount();
    this.getWeChatMessageCount();
  },
  filters: {
    serialNoFilter: function serialNoFilter(serialNo) {
      if (serialNo && serialNo != '') {
        return decrypt(serialNo);
      } else {
        return "";
      }
    }
  },
  methods: {
    //2024-08-19 ZLS  新增获取待办任务的数量
    getConsentFormCount: function getConsentFormCount() {
      var _this = this;

      var loginuser = JSON.parse(localStorage.getItem("loginuser"));

      if (loginuser == null) {
        return;
      }

      var param = {
        patientid: loginuser.patientid
      };

      _getConsentFormCount(param).then(function (res) {
        if (res.code == 200 && res.data > 0) {
          _this.task = res.data;
        }
      });
    },
    toDetail: function toDetail(item) {
      this.$router.push({
        name: 'letterConsentForm',
        query: {
          serialNo: item.serialNo,
          groupID: item.groupID,
          signType: item.signType
        }
      });
    },
    toPreview: function toPreview(item) {
      this.$router.push({
        name: 'letterConsentPreview',
        query: {
          informedID: item.informedID
        }
      });
    },
    //切换
    toggle: function toggle() {
      if (this.activeTabs == 0) {
        //查询进行中的
        this.quests = this.questList.filter(function (item) {
          return item.status == "0";
        });
      } else if (this.activeTabs == 1) {
        //查询已完成的
        this.quests = this.questList.filter(function (item) {
          return item.status == "1";
        });
      } else if (this.activeTabs == 2) {
        //查询所有的
        this.quests = this.questList;
      }
    },
    getConsentFormList: function getConsentFormList() {
      var _this2 = this;

      var loginuser = JSON.parse(localStorage.getItem("loginuser"));
      var patientid = '';

      if (loginuser) {
        patientid = loginuser.patientid;
      }

      var param = {
        patientid: patientid,
        serialNo: this.serialNo,
        startDate: this.startDate,
        endDate: this.endDate
      };

      _getConsentFormList(param).then(function (res) {
        if (res.code == 200) {
          _this2.questList = res.data;

          _this2.toggle();
        }
      });
    },
    filter: function filter() {
      this.filterShow = true;
    },
    formatDate: function formatDate(date) {
      return "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
    },
    onConfirm: function onConfirm(date) {
      var _date = _slicedToArray(date, 2),
          start = _date[0],
          end = _date[1];

      this.screenTimeShow = 0;
      this.show = false;
      this.startDate = "".concat(this.formatDate(start));
      this.endDate = "".concat(this.formatDate(end));
    },
    filterClose: function filterClose(item) {
      this.filterShow = false;

      if (item == 0) {
        this.screenTimeShow = 1;
        this.startDate = null;
        this.endDate = null;
        this.iconColor = '#000000';
        this.getConsentFormList();
      } else {
        this.iconColor = '#1989fa';
        this.getConsentFormList();
      }
    },
    screenTime: function screenTime(item) {
      this.screenTimeShow = item; // 输出结果

      this.startDate = this.getTime(item);
      this.endDate = this.getTime(0);
    },
    getTime: function getTime(item) {
      // 获取当前时间
      var currentDate = new Date(); // 往后推一年

      var formattedDate = currentDate.getFullYear() - item + '-' + (currentDate.getMonth() + 1).toString().padStart(2, '0') + '-' + currentDate.getDate().toString().padStart(2, '0');
      return formattedDate;
    },
    toHome: function toHome() {
      this.$router.push({
        name: 'home'
      });
    },
    toUserinfo: function toUserinfo() {
      this.$router.push({
        name: 'userinfo'
      });
    },
    toOrders: function toOrders() {
      this.$router.push({
        name: 'orders'
      });
    },
    toMessage: function toMessage() {
      this.$router.push({
        name: 'message'
      });
    },
    getWeChatMessageCount: function getWeChatMessageCount() {
      var _this3 = this;

      if (!this.messageShow) {
        return;
      }

      var loginuser = JSON.parse(localStorage.getItem("loginuser"));

      if (!this.messageInterval) {
        _getWeChatMessageCount({
          patientID: loginuser.patientid
        }).then(function (res) {
          var messageCount = localStorage.getItem("messageCount");
          _this3.messageCount = res.data - messageCount;
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    // 或者使用 unmounted
    if (this.messageInterval) {
      clearInterval(this.messageInterval);
    }
  }
};